import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Typography, useTheme } from '@mui/material';

import { TalentDTO, useGetTalentById, useGetTalentProcesses } from '@/api/generated';
import EmptyState from '@/components/EmptyState';
import Loader from '@/components/Loader/Loader';

import TalentProcess from './TalentProcess/TalentProcess';

const TalentProcessesList = () => {
  const params = useParams<{ talentId: string; testSessionId?: string }>();
  const { data: talent, isFetched: isTalentFetched } = useGetTalentById<TalentDTO>(params.talentId!);
  const { data, isFetched: isProcessesFetched } = useGetTalentProcesses(params.talentId!, {
    query: { suspense: false }
  });
  const processes = data?.processes ?? [];

  const { spacing, typography, palette } = useTheme();
  const isExpandedView = processes.length === 1 && processes[0].testSessionSummaries?.length === 1;
  const { t } = useTranslation('talents');

  if (!isTalentFetched || !isProcessesFetched)
    return (
      <Box p={spacing(5)}>
        <Loader />
      </Box>
    );

  return (
    <Box p={spacing(5)}>
      {talent && processes.length ? (
        processes.map(process => (
          <TalentProcess talent={talent} key={process.id} process={process} isExpandedView={isExpandedView} />
        ))
      ) : (
        <EmptyState
          buttonLabel={t('layouts.talent.addProcess')}
          imageUrl="/images/empty-state-illustration.png"
          imageAlt={t('layouts.talent.talentEmptyAlt')}
        >
          <Typography variant="body2" sx={{ fontWeight: typography.fontWeightMedium, color: palette.grey[700] }}>
            <Trans
              t={t}
              i18nKey="layouts.talent.talentEmptyStateText"
              components={{
                br: <br />
              }}
            />
          </Typography>
        </EmptyState>
      )}
    </Box>
  );
};

export default TalentProcessesList;
